(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["wishlist"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('custom-wishlist')) {
    customElements.define('custom-wishlist', class CustomWishlist extends HTMLElement {
      connectedCallback() {
        this.grid = this.querySelector('[data-wishlist-grid]');
        this.template = this.querySelector('[data-wishlist-card-template]');
        this.controls = this.querySelector('[data-wishlist-controls]');
        this.shareButton = this.querySelector('[data-wishlist-share]');
        this.adoptButton = this.querySelector('[data-wishlist-adopt]');
        this.buyAllButton = this.querySelector('[data-wishlist-buy-all]');
        this.loginHint = this.querySelector('[data-wishlist-login-hint]');
        this.states = {
          loading: this.querySelector('[data-wishlist-loading]'),
          empty: this.querySelector('[data-wishlist-empty]'),
          error: this.querySelector('[data-wishlist-error]')
        };

        this.sharedId = this.readSharedId();
        this.wishlistId = null;

        this.setupShare();
        this.setupAdopt();
        this.setupBuyAll();
        this.setupClear();
        this.load();
      }

      // "Merkliste loeschen": der Button in der Leiste oeffnet nur das Modal
      // (Theme-Mechanik ueber aria-controls). Geloescht wird beim Bestaetigen.
      setupClear() {
        this.clearButton = this.querySelector('[data-wishlist-clear]');
        this.clearModal = this.querySelector('[data-wishlist-clear-modal]');
        if (!this.clearButton || !this.clearModal) return;

        this.clearConfirm = this.clearModal.querySelector('[data-wishlist-clear-confirm]');
        this.clearConfirm.addEventListener('click', () => this.clearList());
      }

      // Alle Eintraege der eigenen Liste loeschen – ueber this.items, nicht
      // ueber die Karten: Eintraege, zu denen die Storefront API kein Produkt
      // mehr liefert, haben keine Karte, sollen aber mit verschwinden.
      async clearList() {
        const items = (this.items || []).slice();
        if (!items.length) {
          this.clearModal.open = false;
          return;
        }

        const defaultLabel = this.clearConfirm.textContent.trim();
        this.clearConfirm.disabled = true;

        try {
          const config = this.swishConfig();
          const headers = this.swishIdentityHeaders(config);
          if (!headers) throw new Error('Keine Identitaet gegenueber Swish – Loeschen nicht moeglich.');

          await Promise.all(items.map((item) => this.deleteItem(config, headers, item)));

          this.items = [];
          this.grid.replaceChildren();
          this.syncHeaderCounter();
          this.invalidateAppCache();
          this.clearModal.open = false;
          this.show('empty');
        } catch (error) {
          console.error('[custom-wishlist]', error);
          this.flashLabel(this.clearConfirm, this.clearConfirm.dataset.labelFailed, defaultLabel);
          // Ein Teil kann schon geloescht sein – Liste neu laden, damit die
          // Anzeige zum echten Stand passt. Das Modal bleibt offen.
          this.show('loading');
          this.load();
        } finally {
          this.clearConfirm.disabled = false;
        }
      }

      // Alle Artikel der angezeigten (fremden) Liste in die eigene uebernehmen.
      // Danach auf die eigene Merkliste wechseln – das laedt zugleich den
      // Herz-Zaehler der App neu.
      setupAdopt() {
        if (!this.adoptButton) return;
        this.adoptLabel = this.adoptButton.querySelector('[data-wishlist-adopt-label]');
        this.adoptButton.addEventListener('click', () => this.adoptList());
      }

      async adoptList() {
        const items = this.items || [];
        if (!items.length) return;

        const defaultLabel = this.adoptLabel.textContent.trim();
        this.adoptButton.disabled = true;

        try {
          const config = this.swishConfig();

          // Ein Gast ohne bisherige Merkliste hat weder Kundennummer noch
          // Session. Trotzdem senden: die API legt beim ersten Schreiben eine
          // Session an – siehe adoptSessionFrom() unten.
          let headers = this.swishIdentityHeaders(config) || {
            'x-appmate-shp': config.shopPermanentDomain
          };

          // Die API prueft beim Anlegen nicht auf Dubletten – ein bereits
          // gemerkter Artikel stuende sonst zweimal in der Liste. Der Satz
          // waechst beim Filtern mit und faengt so auch Dubletten innerhalb
          // der geteilten Liste ab.
          const known = new Set((await this.fetchOwnItems()).map(this.itemKey));
          const pending = items.filter((item) => {
            const key = this.itemKey(item);
            if (known.has(key)) return false;
            known.add(key);
            return true;
          });

          if (pending.length) {
            // Der Endpunkt nimmt nur einen Eintrag pro Aufruf – Sammelformate
            // quittiert er mit 400. Also n Requests, aber gleichzeitig.
            if (this.swishIdentityHeaders(config)) {
              await Promise.all(pending.map((item) => this.addItem(config, headers, item)));
            } else {
              // Ohne Identitaet legt jeder Aufruf eine eigene Session an. Den
              // ersten deshalb allein senden und dessen Session uebernehmen.
              headers = await this.addItem(config, headers, pending[0]);
              await Promise.all(pending.slice(1).map((item) => this.addItem(config, headers, item)));
            }

            // Abwarten, weil gleich die Seite wechselt und die eigene Liste
            // samt Herz-Zaehler sonst aus dem alten Cache kaeme.
            await this.invalidateAppCache();
          }

          // Deutlich bestaetigen, bevor die Seite wechselt – sonst waere der
          // einzige sichtbare Hinweis der Sprung auf die eigene Merkliste.
          // Text allein reicht nicht (zu aehnlich), daher auch Haken und Farbe.
          this.adoptButton.querySelector('[data-wishlist-adopt-icon="default"]').hidden = true;
          this.adoptButton.querySelector('[data-wishlist-adopt-icon="success"]').hidden = false;
          this.adoptButton.classList.add('wishlist__action--success');
          this.adoptLabel.textContent = this.adoptButton.dataset.labelSuccess;
          setTimeout(() => window.location.assign(this.ownListUrl()), 1500);
        } catch (error) {
          console.error('[custom-wishlist]', error);
          this.adoptButton.disabled = false;
          this.flashLabel(this.adoptLabel, this.adoptButton.dataset.labelFailed, defaultLabel);
        }
      }

      // Ein Eintrag anlegen. Nutzlast spiegelt die Item-Struktur der Leseantwort
      // (productId / variantId) – so verifiziert. Achtung: die POST-Antwort
      // nennt das Feld abweichend selectedVariantId.
      // Rueckgabe: die ggf. um eine neue Session ergaenzten Header.
      async addItem(config, headers, item) {
        const res = await fetch(config.apiHost + '/wishlists/mine/items', {
          method: 'POST',
          headers: Object.assign({ 'content-type': 'application/json' }, headers),
          body: JSON.stringify({ productId: item.productId, variantId: item.variantId })
        });
        if (!res.ok) throw new Error('Swish API ' + res.status + ' (POST /wishlists/mine/items)');

        return this.adoptSessionFrom(await res.json().catch(() => null), headers);
      }

      // Alle verfuegbaren Artikel der angezeigten Liste in den Warenkorb legen.
      // Eigene Liste: die gekauften Artikel danach aus der Merkliste entfernen
      // (Martin, 2026-09-02) – die Merkliste ist damit ein Einkaufszettel, kein
      // Archiv. Ausverkaufte Artikel kommen nicht in den Warenkorb und bleiben
      // deshalb auch gemerkt.
      setupBuyAll() {
        if (!this.buyAllButton) return;
        this.buyAllLabel = this.buyAllButton.querySelector('[data-wishlist-buy-all-label]');
        this.buyAllButton.addEventListener('click', () => this.buyAll());
      }

      async buyAll() {
        const cards = Array.from(this.grid.children).filter((card) =>
          card._wishlist && card._wishlist.variantId && !card._wishlist.soldOut
        );
        if (!cards.length) return;

        const defaultLabel = this.buyAllLabel.textContent.trim();
        this.buyAllButton.disabled = true;

        try {
          const { response, json } = await this.addToCart(
            cards.map((card) => ({ id: card._wishlist.variantId, quantity: 1 }))
          );

          if (response.ok && !this.sharedId) {
            // Erst entfernen, dann melden: bei Warenkorb-Typ "page" leitet
            // notifyCartAdded auf den Warenkorb weiter, danach liefe nichts mehr.
            await Promise.all(cards.map((card) => this.removeItem(card._wishlist.item, card)));
          }

          this.notifyCartAdded(response, json);
          if (!response.ok) this.flashLabel(this.buyAllLabel, this.buyAllButton.dataset.labelFailed, defaultLabel);
        } catch (error) {
          console.error('[custom-wishlist]', error);
          this.flashLabel(this.buyAllLabel, this.buyAllButton.dataset.labelFailed, defaultLabel);
        } finally {
          this.buyAllButton.disabled = false;
        }
      }

      // Mehrere Artikel in einem Request – derselbe Endpunkt, den auch
      // <form is="product-form"> im Theme nutzt (assets/theme.js, ProductForm).
      async addToCart(items) {
        const response = await fetch(window.themeVariables.routes.cartAddUrl + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ items, sections: ['mini-cart'] })
        });
        const json = await response.json().catch(() => ({}));
        return { response, json };
      }

      // Nachbau der Ereigniskette aus ProductForm._onSubmit, damit Drawer,
      // Zaehler und Benachrichtigung des Themes genauso reagieren wie beim
      // Kauf ueber eine einzelne Karte.
      notifyCartAdded(response, json) {
        const settings = window.themeVariables.settings;

        if (response.ok) {
          if (settings.cartType === 'page' || settings.pageType === 'cart') {
            window.location.href = Shopify.routes.root + 'cart';
            return;
          }

          fetch(window.themeVariables.routes.cartUrl + '.js').then(async (res) => {
            const cart = await res.json();
            document.documentElement.dispatchEvent(new CustomEvent('cart:updated', {
              bubbles: true,
              detail: { cart }
            }));
            cart.sections = json.sections;
            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
              bubbles: true,
              detail: { cart, openMiniCart: settings.cartType === 'drawer' }
            }));
          });
        } else {
          this.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        }

        this.dispatchEvent(new CustomEvent('cart-notification:show', {
          bubbles: true,
          cancelable: true,
          detail: {
            status: response.ok ? 'success' : 'error',
            error: json.description || ''
          }
        }));
      }

      // Merkzettel-Eintraege sind variantengenau, deshalb beides im Schluessel.
      itemKey(item) {
        return item.productId + ':' + (item.variantId || '');
      }

      // Eigene Liste – unabhaengig davon, welche Liste die Seite gerade zeigt.
      async fetchOwnItems() {
        const config = this.swishConfig();
        const headers = this.swishIdentityHeaders(config);
        if (!headers) return [];

        const res = await fetch(config.apiHost + '/wishlists/mine', { headers });
        if (!res.ok) throw new Error('Swish API ' + res.status + ' (/wishlists/mine)');

        const { wishlist } = await res.json();
        return (wishlist && wishlist.items) || [];
      }

      // Die Antwort auf einen Schreibzugriff enthaelt sessionId auf oberster
      // Ebene (nicht innerhalb von wishlist, wie beim Lesen). Ohne Session im
      // localStorage faende weder die App noch ein spaeterer Seitenaufruf die
      // Artikel wieder. Gibt die ggf. ergaenzten Header zurueck.
      adoptSessionFrom(payload, headers) {
        const sessionId = payload && payload.sessionId;
        if (!sessionId || localStorage.getItem('wk_session_id')) return headers;

        localStorage.setItem('wk_session_id', sessionId);
        return Object.assign({}, headers, { 'x-appmate-sid': sessionId });
      }

      // Derselbe Pfad ohne die angehaengte publicId.
      ownListUrl() {
        const parts = window.location.pathname.replace(/\/+$/, '').split('/');
        if (this.sharedId) parts.pop();
        return parts.join('/') || '/';
      }

      // Geteilte Liste: /<seitenpfad>/<publicId>. Bewusst NICHT ueber den
      // Seiten-Handle aus Liquid erkannt – auf einem Unterpfad liefert Shopify
      // das page-Objekt nicht zuverlaessig. Stattdessen am Format der ID
      // festgemacht (24-stellige Hex-ID, siehe publicId der Swish-API).
      isPublicId(value) {
        return typeof value === 'string' && /^[0-9a-f]{24}$/i.test(value);
      }

      readSharedId() {
        const last = window.location.pathname.replace(/\/+$/, '').split('/').pop();
        return this.isPublicId(last) ? last : null;
      }

      // Aus dem aktuellen Pfad abgeleitet, damit Seiten-Slug sowie Sprach- und
      // Market-Praefixe automatisch stimmen.
      shareUrl() {
        if (!this.wishlistId) return null;
        const parts = window.location.pathname.replace(/\/+$/, '').split('/');
        if (this.sharedId) parts.pop();
        return window.location.origin + parts.join('/') + '/' + this.wishlistId;
      }

      show(state) {
        this.states.loading.hidden = state !== 'loading';
        this.states.empty.hidden = state !== 'empty';
        this.states.error.hidden = state !== 'error';
        this.grid.hidden = state !== 'grid';

        // Teilen zeigt in der geteilten Ansicht denselben Link – bleibt sinnvoll.
        if (this.shareButton) {
          this.shareButton.hidden = state !== 'grid' || !this.shareUrl();
        }

        if (this.adoptButton) {
          this.adoptButton.hidden = state !== 'grid';
        }

        if (this.buyAllButton) {
          this.buyAllButton.hidden = state !== 'grid';
        }

        if (this.clearButton) {
          this.clearButton.hidden = state !== 'grid';
        }

        // Login-Hinweis auch bei leerer Liste zeigen – dort ist er sogar
        // besonders sinnvoll (Liste liegt evtl. auf einem anderen Geraet).
        // In fremden Listen nicht, da geht es nicht um die eigene Merkliste.
        if (this.loginHint) {
          this.loginHint.hidden = (state !== 'grid' && state !== 'empty') || Boolean(this.sharedId);
        }

        // Aktionsleiste nur, wenn Artikel gelistet sind.
        if (this.controls) {
          this.controls.hidden = state !== 'grid';
        }
      }

      setupShare() {
        if (!this.shareButton) return;
        this.shareLabel = this.shareButton.querySelector('[data-wishlist-share-label]');
        const defaultLabel = this.shareLabel.textContent.trim();

        this.shareButton.addEventListener('click', async () => {
          const url = this.shareUrl();
          if (!url) return;

          const text = this.buildShareText();

          if (navigator.share) {
            try {
              // text + url getrennt: Messenger haengen die URL selbst an und
              // ziehen daraus die Linkvorschau.
              await navigator.share({ title: this.shareButton.dataset.shareHeading, text, url });
              return;
            } catch (error) {
              if (error.name === 'AbortError') return;
            }
          }

          const dataset = this.shareButton.dataset;
          try {
            await navigator.clipboard.writeText(text + '\n' + url);
            this.flashLabel(this.shareLabel, dataset.labelCopied, defaultLabel);
          } catch (error) {
            console.error('[custom-wishlist]', error);
            this.flashLabel(this.shareLabel, dataset.labelFailed, defaultLabel);
          }
        });
      }

      // Lesbare Nachricht statt nacktem Link. Hoechstens drei Artikel nennen –
      // laengere Listen werden in Messengern abgeschnitten und der eigentliche
      // Link ginge unter.
      buildShareText() {
        const data = this.shareButton.dataset;
        // Aus den sichtbaren Karten, nicht aus einer Liste vom Laden – nach
        // Entfernen oder Kauf stimmt der Text sonst nicht mehr.
        const titles = Array.from(this.grid.children)
          .map((card) => card._wishlist && card._wishlist.shareTitle)
          .filter(Boolean);
        const shown = titles.slice(0, 3);

        const lines = [data.shareHeading, ''];
        shown.forEach((title) => lines.push('• ' + title));

        if (titles.length > shown.length) {
          lines.push(data.shareMore.replace('[COUNT]', titles.length - shown.length));
        }

        lines.push('', data.shareCta);
        return lines.join('\n');
      }

      // Kurze Rueckmeldung im Button, danach zurueck zur Beschriftung.
      flashLabel(element, message, defaultLabel) {
        element.textContent = message;
        clearTimeout(element._labelTimer);
        element._labelTimer = setTimeout(() => {
          element.textContent = defaultLabel;
        }, 2500);
      }

      async load() {
        try {
          const items = await this.fetchWishlistItems();
          // Fuer "Merkliste uebernehmen" und den Header-Zaehler gebraucht;
          // removeItem haelt die Liste aktuell.
          this.items = items;
          if (!items.length) return this.show('empty');

          const nodes = await this.fetchProducts(items);

          // Index-treu bleiben: die Karte braucht spaeter die Merkzettel-Item-ID
          // aus items[i], nicht nur die Produktdaten aus nodes[i].
          const cards = nodes
            .map((node, index) => (node ? this.buildCard(node, items[index]) : null))
            .filter(Boolean);

          if (!cards.length) {
            // Wichtig fuer die Fehlersuche: "Merkliste leer" und "Produkte nicht
            // aufloesbar" sehen fuer den Kunden gleich aus, haben aber voellig
            // verschiedene Ursachen (z. B. Storefront-Token, Sales-Channel, Markt).
            console.warn('[custom-wishlist] Merkzettel enthaelt', items.length, 'Eintraege, die Storefront API liefert dazu keine Produkte:', items);
            return this.show('empty');
          }

          this.grid.replaceChildren(...cards);
          this.show('grid');
        } catch (error) {
          console.error('[custom-wishlist]', error);
          this.show('error');
        }
      }

      // Den Merklisten-Cache der App verwerfen. Nach jedem eigenen
      // Schreibzugriff aufrufen (Entfernen, Sammelkauf, Uebernehmen).
      //
      // Hintergrund (Browser-Protokoll 2026-09-04): die App haelt die Merkliste
      // in der Cache Storage API unter "wk-wishlist-v1", ein Eintrag je
      // Seitentyp (Header x-appmate-src). Sie rendert erst aus dem Cache und
      // laedt dann nach, ohne die Anzeige zu aktualisieren. Unsere Zugriffe
      // gehen an der App vorbei, also bleiben ihre Eintraege stehen und die
      // naechste Produktseite zeigt "Produkt ist auf Merkliste" samt altem
      // Herz-Zaehler. Ohne Cache-Eintrag laedt die App frisch.
      //
      // Best effort: caches fehlt in unsicheren Kontexten und kann werfen –
      // dann bleibt es beim bisherigen Verhalten, der Schreibzugriff selbst
      // ist davon unabhaengig.
      async invalidateAppCache() {
        try {
          if (window.caches) await caches.delete('wk-wishlist-v1');
        } catch (error) {
          console.warn('[custom-wishlist] App-Cache konnte nicht geleert werden', error);
        }
      }

      // Die App-Config liegt als JSON im DOM. Einziger nicht-dokumentierter
      // Teil der Integration -> hier gekapselt.
      swishConfig() {
        const settingsEl = document.getElementById('wkAppSettings');
        if (!settingsEl) throw new Error('wkAppSettings nicht gefunden – Swish-App aktiv?');
        return JSON.parse(settingsEl.textContent).config;
      }

      // Identifikation gegenueber Swish, exakt wie die App sie schickt:
      //   x-appmate-cid = Shopify-Kundennummer -> geraeteuebergreifend
      //   x-appmate-sid = Session aus dem localStorage -> nur dieses Geraet
      // Gibt null zurueck, wenn keine der beiden Identitaeten vorliegt.
      swishIdentityHeaders(config) {
        const sid = localStorage.getItem('wk_session_id');
        const customerId = this.dataset.customerId;
        if (!sid && !customerId) return null;

        const headers = { 'x-appmate-shp': config.shopPermanentDomain };
        if (sid) headers['x-appmate-sid'] = sid;
        if (customerId) {
          headers['x-appmate-cid'] = customerId;
          // Von der App uebernommen: markiert den Aufruf als Seitenaufruf und
          // loest die Zuordnung der Gast-Liste zum Konto aus.
          headers['x-appmate-src'] = 'page';
          headers['x-appmate-vca'] = 'true';
          headers['x-appmate-vcm'] = 'true';
        }
        return headers;
      }

      // Stufe 1 – IDs aus Swish.
      async fetchWishlistItems() {
        const config = this.swishConfig();

        // Geteilte Liste: ohne Identifikation, die ID kommt aus der URL.
        let path = '/wishlists/' + encodeURIComponent(this.sharedId);
        let headers = { 'x-appmate-shp': config.shopPermanentDomain };

        if (!this.sharedId) {
          headers = this.swishIdentityHeaders(config);
          if (!headers) {
            console.warn('[custom-wishlist] Weder Kundennummer noch Session vorhanden – es wird nichts abgefragt. Eingeloggt? data-customer-id am <custom-wishlist> pruefen.');
            return [];
          }
          path = '/wishlists/mine';
        }

        const res = await fetch(config.apiHost + path, { headers });
        if (!res.ok) throw new Error('Swish API ' + res.status + ' (' + path + ')');

        const { wishlist } = await res.json();

        // Oeffentliche ID -> Grundlage fuer den Teilen-Link.
        this.wishlistId = this.sharedId || this.extractPublicId(wishlist);
        return (wishlist && wishlist.items) || [];
      }

      // Einzelnen Eintrag loeschen. Die Item-ID ist NICHT die Produkt- oder
      // Varianten-ID, sondern die ID des Merkzettel-Eintrags aus Stufe 1.
      // button ist optional (beim Sammel-Entfernen nach "in den Warenkorb").
      // Schlaegt das Loeschen fehl, bleibt die Karte stehen – ein Reload zeigt
      // dann den echten Stand.
      async removeItem(item, cardEl, button) {
        const config = this.swishConfig();
        const headers = this.swishIdentityHeaders(config);
        if (!headers || !item || !item.id) return;

        if (button) button.disabled = true;

        try {
          await this.deleteItem(config, headers, item);

          this.items = (this.items || []).filter((entry) => entry !== item);
          cardEl.remove();
          this.syncHeaderCounter();
          if (!this.grid.children.length) this.show('empty');

          // Nicht abwarten: die Karte ist schon weg, der Cache betrifft nur
          // die naechste Seite. Bei Sammel-Entfernen laeuft das n-mal, das
          // Loeschen eines fehlenden Caches ist aber ein No-op.
          this.invalidateAppCache();
        } catch (error) {
          console.error('[custom-wishlist]', error);
          if (button) button.disabled = false;
        }
      }

      // Der reine API-Aufruf, ohne DOM. Genutzt von removeItem (einzeln,
      // Kauf, Sammelkauf) und clearList.
      async deleteItem(config, headers, item) {
        const res = await fetch(config.apiHost + '/wishlists/mine/items', {
          method: 'DELETE',
          headers: Object.assign({ 'content-type': 'application/json' }, headers),
          body: JSON.stringify({ wishlistItemId: item.id })
        });
        if (!res.ok) throw new Error('Swish API ' + res.status + ' (DELETE /wishlists/mine/items)');
      }

      // Den Herz-Zaehler im Header (sections/header.liquid) nachziehen. Die
      // App fuellt ihn nur beim Seitenaufruf; nach Entfernen oder Kauf stuende
      // sonst bis zum naechsten Reload die alte Zahl dort. Best effort: fehlt
      // das Markup, passiert nichts.
      syncHeaderCounter() {
        const count = (this.items || []).length;
        document.querySelectorAll('.wishlist-header-link .wkh-counter').forEach((el) => {
          el.textContent = count;
        });
        document.querySelectorAll('.wishlist-header-link .wkh-button').forEach((el) => {
          el.classList.toggle('wkh-selected', count > 0);
        });
      }

      // Bei /wishlists/mine spiegelt die Antwort das Alias "mine" in wishlist.id
      // wider – als Teilen-Link unbrauchbar. Die oeffentliche ID ist eine
      // 24-stellige Hex-ID; das Feld ist nicht dokumentiert, also gezielt danach
      // suchen statt einen Feldnamen zu raten.
      extractPublicId(wishlist) {
        if (!wishlist) return null;

        for (const key of ['publicId', 'id']) {
          if (this.isPublicId(wishlist[key])) return wishlist[key];
        }

        const fallback = Object.values(wishlist).find((value) => this.isPublicId(value));
        if (fallback) return fallback;

        console.warn('[custom-wishlist] Keine oeffentliche Wunschlisten-ID gefunden. Vorhandene Felder:', Object.keys(wishlist));
        return null;
      }

      // Stufe 2 – Produktdaten aus der Storefront API. Ein Request fuer alle Items.
      // Variant-GIDs (wishlistMode = VARIANT), Fallback Produkt-GID. @inContext = Market/Sprache.
      async fetchProducts(items) {
        const token = this.dataset.storefrontToken;
        if (!token) throw new Error('Storefront-Token fehlt (Theme-Einstellung Wishlist)');

        const ids = items.map((item) =>
          item.variantId
            ? 'gid://shopify/ProductVariant/' + item.variantId
            : 'gid://shopify/Product/' + item.productId
        );

        const query = `query WL($ids:[ID!]!, $country:CountryCode!, $language:LanguageCode!) @inContext(country:$country, language:$language) {
          nodes(ids:$ids) {
            ... on ProductVariant { id title availableForSale price { amount currencyCode } image { url altText width height } product { title handle vendor featuredImage { url altText width height } ...Reviews } }
            ... on Product { id title handle vendor availableForSale featuredImage { url altText width height } priceRange { minVariantPrice { amount currencyCode } } ...Reviews }
          }
        }

        fragment Reviews on Product {
          metafields(identifiers: [
            { namespace: "reviews", key: "reviews_io_rating" },
            { namespace: "reviews", key: "reviews_io_count" }
          ]) { key value }
        }`;

        const endpoint = this.dataset.rootUrl.replace(/\/$/, '') + '/api/' + this.dataset.apiVersion + '/graphql.json';
        const variables = {
          ids,
          country: this.dataset.country,
          language: (this.dataset.language || 'DE').toUpperCase()
        };

        const res = await fetch(endpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Shopify-Storefront-Access-Token': token },
          body: JSON.stringify({ query, variables })
        });
        if (!res.ok) throw new Error('Storefront API ' + res.status);

        const json = await res.json();
        if (json.errors) throw new Error(json.errors.map((e) => e.message).join(', '));

        const nodes = json.data.nodes;
        nodes.forEach((node, index) => {
          if (!node) console.warn('[custom-wishlist] Storefront API kennt', ids[index], 'nicht (nicht im Verkaufskanal, geloescht oder im Markt', variables.country, 'nicht verfuegbar).');
        });

        return nodes;
      }

      // Stufe 3 – schlanke, variantengenaue Karte. Austauschpunkt: fuer 1:1-Theme-Karten
      // wuerde hier stattdessen die Section-Rendering-API pro Handle greifen.
      buildCard(node, item) {
        const isVariant = node.image !== undefined || node.product !== undefined;
        const product = isVariant ? node.product : node;
        const image = (isVariant && node.image) || product.featuredImage;
        const money = isVariant ? node.price : node.priceRange.minVariantPrice;

        // Bewusst dreiwertig: true / false / unbekannt. "Ausverkauft" wird nur
        // bei einem echten false gezeigt – fehlt das Feld, ist ein faelschlich
        // ausverkauft wirkendes Produkt der teurere Fehler.
        const soldOut = node.availableForSale === false;
        if (typeof node.availableForSale !== 'boolean') {
          console.warn('[custom-wishlist] availableForSale fehlt fuer', node.id, '– Verfuegbarkeit wird nicht angezeigt.', node);
        }

        const card = this.template.content.cloneNode(true);
        const url = new URL(this.dataset.rootUrl.replace(/\/$/, '') + '/products/' + product.handle, window.location.origin);
        if (isVariant) url.searchParams.set('variant', node.id.split('/').pop());
        card.querySelectorAll('[data-wishlist-link]').forEach((link) => {
          link.href = url.pathname + url.search;
        });

        const img = card.querySelector('.product-item__primary-image');
        if (image) {
          const src = new URL(image.url);
          src.searchParams.set('width', '600');
          img.src = src.toString();
          img.alt = image.altText || product.title;
          img.hidden = false;

          // Nur relevant, wenn das Theme auf "natural" steht – die Klassen
          // aspect-ratio--square/short/tall ueberschreiben das per !important.
          if (image.width && image.height) {
            img.width = image.width;
            img.height = image.height;

            const ratioEl = card.querySelector('.product-item__aspect-ratio');
            ratioEl.style.setProperty('--aspect-ratio', image.width / image.height);
            ratioEl.style.paddingBottom = (100 * image.height / image.width) + '%';
          }
        }

        // Nur vorhanden, wenn die Theme-Einstellung "Marke anzeigen" aktiv ist.
        const vendorEl = card.querySelector('[data-wishlist-vendor]');
        if (vendorEl && product.vendor) {
          vendorEl.textContent = product.vendor;
          vendorEl.hidden = false;
        }

        card.querySelector('[data-wishlist-title]').textContent = product.title;

        // "Default Title" ist Shopifys Platzhalter fuer Produkte ohne echte
        // Varianten und darf nicht angezeigt werden.
        const variantTitle = isVariant && node.title !== 'Default Title' ? node.title : '';

        if (variantTitle) {
          card.querySelector('[data-wishlist-variant-title]').textContent = variantTitle;
          card.querySelector('[data-wishlist-variant-title]').hidden = false;
          card.querySelector('[data-wishlist-variant-break]').hidden = false;
        }
        this.renderRating(card.querySelector('[data-wishlist-rating]'), product);

        card.querySelector('[data-wishlist-price]').textContent = this.formatMoney(money);
        card.querySelector('[data-wishlist-labels]').hidden = !soldOut;

        const cardEl = card.firstElementChild;
        cardEl.classList.toggle('product-item--sold-out', soldOut);

        // Entfernen nur in der eigenen Liste – fremde Listen sind schreibgeschuetzt.
        const canRemove = Boolean(item && item.id && !this.sharedId);
        const removeButton = card.querySelector('[data-wishlist-remove]');
        if (removeButton && canRemove) {
          removeButton.hidden = false;
          removeButton.addEventListener('click', () => this.removeItem(item, cardEl, removeButton));
        }

        // Was buyAll und buildShareText spaeter von der Karte brauchen.
        cardEl._wishlist = {
          item,
          variantId: isVariant ? node.id.split('/').pop() : null,
          soldOut,
          shareTitle: variantTitle ? product.title + ' – ' + variantTitle : product.title
        };

        // Nur fuer Varianten-Eintraege: ohne Varianten-ID gibt es nichts, was
        // eindeutig in den Warenkorb koennte. Die App laeuft auf wishlist_mode
        // VARIANT, es sind also praktisch alle Eintraege.
        const form = card.querySelector('[data-wishlist-form]');
        if (form && isVariant) {
          form.querySelector('[data-wishlist-variant-id]').value = cardEl._wishlist.variantId;
          form.hidden = false;

          // Nach dem Kauf ueber die Karte aus der Merkliste entfernen (Martin,
          // 2026-09-02). variant:added feuert ProductForm nur bei Erfolg – bei
          // Warenkorb-Typ "page" gar nicht, weil vorher weitergeleitet wird;
          // dann bleibt der Artikel gemerkt.
          if (canRemove) {
            form.addEventListener('variant:added', () => this.removeItem(item, cardEl, removeButton));
          }

          if (soldOut) {
            // Gleiche Darstellung wie auf der PDP: abgesetzter, deaktivierter
            // Button statt gar keinem. Muss vor dem Einhaengen passieren, weil
            // is="loader-button" beim Upgrade den Inhalt umbaut.
            const button = form.querySelector('button');
            button.textContent = button.dataset.labelSoldOut;
            button.classList.replace('button--primary', 'button--ternary');
            button.disabled = true;
          }
        }

        return cardEl;
      }

      // Bewertungen kommen aus denselben Metafeldern wie in der Collection
      // (reviews.reviews_io_rating / reviews.reviews_io_count). Die Abstufung
      // in 25-Prozent-Schritten ist 1:1 aus product-item.liquid uebernommen.
      renderRating(container, product) {
        if (!container) return;

        const metafields = product.metafields || [];
        const read = (key) => {
          const field = metafields.find((entry) => entry && entry.key === key);
          return field ? field.value : null;
        };

        const rating = parseFloat(read('reviews_io_rating'));
        if (!Number.isFinite(rating)) return;

        const count = read('reviews_io_count') || '0';
        const label = rating + ' Stars - ' + count;
        container.title = label;
        container.setAttribute('aria-label', label);

        for (let position = 1; position <= 5; position += 1) {
          const remainder = rating - position + 1;
          const percentage = remainder >= 1 ? 100
            : remainder >= 0.75 ? 75
            : remainder >= 0.5 ? 50
            : remainder >= 0.25 ? 25
            : 0;

          const star = document.createElement('i');
          star.setAttribute('aria-hidden', 'true');
          star.className = 'ruk-icon-percentage-star--' + percentage;
          container.appendChild(star);
        }

        const countEl = document.createElement('span');
        countEl.setAttribute('aria-hidden', 'true');
        countEl.className = 'ruk-rating-snippet-count';
        countEl.textContent = '(' + count + ')';
        container.appendChild(countEl);

        container.hidden = false;
      }

      formatMoney(money) {
        if (!money) return '';
        try {
          return new Intl.NumberFormat(this.dataset.language || 'de', {
            style: 'currency', currency: money.currencyCode
          }).format(parseFloat(money.amount));
        } catch (e) {
          return money.amount + ' ' + money.currencyCode;
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
